function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to get private field on non-instance"); } if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to set private field on non-instance"); } if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } return value; }

import photon from "@silvia-odwyer/photon-node";
import fetch from "cross-fetch";

const convertBlobToBase64 = blob => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = reject;

  reader.onload = () => {
    resolve(reader.result);
  };

  reader.readAsDataURL(blob);
});

var _src = new WeakMap();

var _image = new WeakMap();

var _isLoaded = new WeakMap();

var _verifyLoaded = new WeakMap();

export class NodeImage {
  constructor(src) {
    _src.set(this, {
      writable: true,
      value: void 0
    });

    _image.set(this, {
      writable: true,
      value: null
    });

    _defineProperty(this, "load", async () => {
      const res = await fetch(_classPrivateFieldGet(this, _src).toString());
      const data = await res.arrayBuffer();
      const blob = new Blob([data]);
      const b64 = await convertBlobToBase64(blob);
      const str = b64.replace(/^data:.*\/.*;base64,/, ``);

      _classPrivateFieldSet(this, _image, photon.PhotonImage.new_from_base64(str));

      return this;
    });

    _isLoaded.set(this, {
      writable: true,
      value: new Error(`Image must be loaded first!`)
    });

    _verifyLoaded.set(this, {
      writable: true,
      value: () => {
        if (!_classPrivateFieldGet(this, _isLoaded)) throw _classPrivateFieldGet(this, _isLoaded);
        return true;
      }
    });

    _defineProperty(this, "getWidth", () => _classPrivateFieldGet(this, _verifyLoaded).call(this) && _classPrivateFieldGet(this, _image).get_width());

    _defineProperty(this, "getHeight", () => _classPrivateFieldGet(this, _verifyLoaded).call(this) && _classPrivateFieldGet(this, _image).get_height());

    _defineProperty(this, "getPixelCount", () => _classPrivateFieldGet(this, _verifyLoaded).call(this) && this.getWidth() * this.getHeight());

    _defineProperty(this, "getImageData", () => _classPrivateFieldGet(this, _verifyLoaded).call(this) && _classPrivateFieldGet(this, _image).get_raw_pixels());

    _defineProperty(this, "resize", (targetWidth, targetHeight) => {
      _classPrivateFieldGet(this, _verifyLoaded).call(this);

      photon.resize(_classPrivateFieldGet(this, _image), targetWidth, targetHeight, 1);
      return this;
    });

    _defineProperty(this, "scaleDown", (maxDimension, quality) => {
      _classPrivateFieldGet(this, _verifyLoaded).call(this);

      const width = this.getWidth();
      const height = this.getHeight();
      const maxSide = Math.max(width, height);
      const ratio = maxDimension > 0 && maxSide > maxDimension ? maxDimension / maxSide : 1 / quality;
      if (ratio < 1) this.resize(width * ratio, height * ratio);
      return this;
    });

    _defineProperty(this, "remove", () => {
      _classPrivateFieldGet(this, _verifyLoaded).call(this);

      _classPrivateFieldSet(this, _image, null);

      return this;
    });

    _classPrivateFieldSet(this, _src, src);
  }

  applyFilter(filter) {
    _classPrivateFieldGet(this, _verifyLoaded).call(this);

    let imageData = this.getImageData();

    if (typeof filter === `function`) {
      let pixels = imageData;
      let n = pixels.length / 4;
      let offset;
      let r;
      let g;
      let b;
      let a;

      for (let i = 0; i < n; i++) {
        offset = i * 4;
        r = pixels[offset + 0];
        g = pixels[offset + 1];
        b = pixels[offset + 2];
        a = pixels[offset + 3]; // Mark ignored color

        if (!filter(r, g, b, a)) pixels[offset + 3] = 0;
      }
    }

    return imageData;
  }

}